import SowDataTableDateColumnItem from './SowDataTableDateColumnItem';

export default SowDataTableDateColumnItem;
